import { useState, useRef } from 'react'
import GA from 'utils/GA'
import analytics from '@mobi/libraries/analytics'
import storage from 'utils/storage'

const useAccordion = ({ innerHeight }) => {
  const [isActive, setActiveState] = useState('')
  const [setHeight, setHeightState] = useState('0px')
  const [isActiveFaq, setActiveStateFaq] = useState(false)

  const contentRef = useRef(null)

  function toggleAccordion(ev) {
    if (ev.currentTarget?.dataset?.unique) {
      analytics.track('elementClicked', {
        location: ev.currentTarget.dataset.makeLocation,
        position: ev.currentTarget.dataset.makePosition,
        elementType: ev.currentTarget.dataset.makeElement,
        text: ev.currentTarget.dataset.makeText
          ? ev.currentTarget.dataset.makeText
          : ev.currentTarget.textContent,
        htmlId: ev.currentTarget.dataset.unique,
        actionOutcome: ev.currentTarget.dataset.makeActionoutcome,
        outboundUrl: ev.currentTarget.dataset.makeOutboundurl,
      })

      GA.customEvent('buttonClick', {
        id: ev.currentTarget.dataset.unique,
        text: ev.currentTarget.textContent,
      })
    }

    if (ev?.currentTarget?.dataset?.makeProductId) {
      analytics.track('productClicked', {
        productId: ev?.currentTarget?.dataset?.makeProductId,
        brand: ev?.currentTarget.dataset?.makeProductBrand,
        category: 'Debt',
        location: 'LIST',
        position: Number(ev?.currentTarget?.dataset?.makeProductPosition),
        price: Number(ev?.currentTarget?.dataset?.makeProductPrice),
        text: ev?.currentTarget?.dataset?.makeProductText,
        variant: isActive === '' ? 'OPEN' : 'CLOSE',
      })
    }

    setActiveStateFaq(!isActiveFaq)
    storage.session.setItem('isActiveFaq', isActiveFaq)

    setActiveState(isActive === '' ? 'active' : '')

    setHeightState(
      isActive === 'active'
        ? '0px'
        : `${innerHeight || contentRef.current.scrollHeight}px`
    )
  }

  return {
    toggleAccordion,
    isActive,
    setHeight,
    contentRef,
  }
}

export default useAccordion
